// test2073
(2073 && 0);
